import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="text-white pt-5 pb-4 mt-auto" style={{ backgroundColor: '#0B1320', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <div className="container">
        {/* Top Header Row: Branding Greeting & Social Media */}
        <div className="d-flex flex-wrap justify-content-between align-items-center pb-4 mb-4 border-bottom border-secondary border-opacity-25">
          <div className="d-flex align-items-center gap-2">
            <h2 className="fw-bold m-0" style={{ fontSize: '2rem', letterSpacing: '-0.5px' }}>
              <img src="/assets/img/logo.png" alt="Eko360 Logo" className="mb-3" style={{ maxHeight: '38px' }} />
            </h2>
            
          </div>
          <div className="d-flex align-items-center gap-3 fs-5 text-secondary">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="text-secondary text-decoration-none hover-white">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://x.com" target="_blank" rel="noreferrer" className="text-secondary text-decoration-none hover-white">
              <i className="fab fa-x-twitter"></i>
            </a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer" className="text-secondary text-decoration-none hover-white">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="text-secondary text-decoration-none hover-white">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" className="text-secondary text-decoration-none hover-white">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>

        {/* Link Columns Row */}
        <div className="row g-4 mb-5" style={{ fontSize: '13px' }}>
          {/* Column 1: Vision */}
          <div className="col-lg-2 col-md-4 col-6">
            <h6 className="text-uppercase fw-bold text-secondary mb-3" style={{ fontSize: '11px', letterSpacing: '1px' }}>
              Vision & Mission
            </h6>
            <ul className="list-unstyled d-flex flex-column gap-2 m-0">
              <li>
                <Link to="/about/mission-and-vision" className="text-white-50 text-decoration-none d-inline-flex align-items-center gap-1 hover-white">
                  <span style={{ color: '#0C9EA9' }}>↗</span> Our Vision
                </Link>
              </li>
              <li>
                <Link to="/about/mission-and-vision" className="text-white-50 text-decoration-none d-inline-flex align-items-center gap-1 hover-white">
                  <span style={{ color: '#0C9EA9' }}>↗</span> Our Mission
                </Link>
              </li>
              <li>
                <Link to="/about/mission-and-vision" className="text-white-50 text-decoration-none d-inline-flex align-items-center gap-1 hover-white">
                  <span style={{ color: '#0C9EA9' }}>↗</span> Core Functions
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 2: Data & Tools */}
          <div className="col-lg-2 col-md-4 col-6">
            <h6 className="text-uppercase fw-bold text-secondary mb-3" style={{ fontSize: '11px', letterSpacing: '1px' }}>
              Data & Tools
            </h6>
            <ul className="list-unstyled d-flex flex-column gap-2 m-0">
              <li>
                <Link to="/public/datasets" className="text-white-50 text-decoration-none d-inline-flex align-items-center gap-1 hover-white">
                  <span style={{ color: '#0C9EA9' }}>↗</span> Public Data
                </Link>
              </li>
              <li>
                <Link to="/interactivity" className="text-white-50 text-decoration-none d-inline-flex align-items-center gap-1 hover-white">
                  <span style={{ color: '#0C9EA9' }}>↗</span> Interactive Analysis
                </Link>
              </li>
              <li>
                <Link to="/slice-and-dice" className="text-white-50 text-decoration-none d-inline-flex align-items-center gap-1 hover-white">
                  <span style={{ color: '#0C9EA9' }}>↗</span> Slice & Dice
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Resources */}
          <div className="col-lg-2 col-md-4 col-6">
            <h6 className="text-uppercase fw-bold text-secondary mb-3" style={{ fontSize: '11px', letterSpacing: '1px' }}>
              Resources
            </h6>
            <ul className="list-unstyled d-flex flex-column gap-2 m-0">
              <li>
                <Link to="/publications" className="text-white-50 text-decoration-none d-inline-flex align-items-center gap-1 hover-white">
                  <span style={{ color: '#0C9EA9' }}>↗</span> Publications
                </Link>
              </li>
              <li>
                <Link to="/submit-dataset" className="text-white-50 text-decoration-none d-inline-flex align-items-center gap-1 hover-white">
                  <span style={{ color: '#0C9EA9' }}>↗</span> Share Data
                </Link>
              </li>
              <li>
                <Link to="/web-resources" className="text-white-50 text-decoration-none d-inline-flex align-items-center gap-1 hover-white">
                  <span style={{ color: '#0C9EA9' }}>↗</span> Web Resources
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Help & Support */}
          <div className="col-lg-3 col-md-6 col-6">
            <h6 className="text-uppercase fw-bold text-secondary mb-3" style={{ fontSize: '11px', letterSpacing: '1px' }}>
              Help & Support
            </h6>
            <ul className="list-unstyled d-flex flex-column gap-2 m-0">
              <li>
                <Link to="/contact" className="text-white-50 text-decoration-none d-inline-flex align-items-center gap-1 hover-white">
                  <span style={{ color: '#0C9EA9' }}>↗</span> Contact Us
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="text-white-50 text-decoration-none d-inline-flex align-items-center gap-1 hover-white">
                  <span style={{ color: '#0C9EA9' }}>↗</span> FAQs
                </Link>
              </li>
              <li>
                <Link to="/terms-of-use/legal" className="text-white-50 text-decoration-none d-inline-flex align-items-center gap-1 hover-white">
                  <span style={{ color: '#0C9EA9' }}>↗</span> Privacy Policy & Terms
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 5: Feedback */}
          <div className="col-lg-3 col-md-6 col-12">
            <h6 className="text-uppercase fw-bold text-secondary mb-3" style={{ fontSize: '11px', letterSpacing: '1px' }}>
              Feedback
            </h6>
            <ul className="list-unstyled d-flex flex-column gap-2 m-0">
              <li>
                <Link to="/contact" className="text-white-50 text-decoration-none d-inline-flex align-items-center gap-1 hover-white">
                  <span style={{ color: '#0C9EA9' }}>↗</span> Give Feedback
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Banner Section */}
        <div
          className="d-flex flex-wrap align-items-center justify-content-between p-3 rounded-3 mb-4"
          style={{ backgroundColor: '#131F33' }}
        >
          <span className="text-white fw-medium mb-2 mb-md-0" style={{ fontSize: '14px' }}>
            Access Lagos State data analytics and insights at your fingertips!
          </span>
          <Link
            to="/public/datasets"
            className="btn btn-sm rounded-2 text-dark fw-bold px-3 py-2 d-inline-flex align-items-center gap-1"
            style={{ backgroundColor: '#0C9EA9', border: 'none', color: '#fff' }}
          >
            <span>Explore Datasets</span> ↗
          </Link>
        </div>

        {/* Copyright and Attribution Footer Bar */}
        <div className="d-flex flex-wrap justify-content-between align-items-center pt-3 border-top border-secondary border-opacity-25 text-secondary" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>
          <div>
            © COPYRIGHT {currentYear}, ALL RIGHTS RESERVED | <span className="text-white-50">LBS</span>
          </div>
          <div>
            POWERED BY <span className="text-white-50">LBS DATA Bank Team</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;